module.exports = __webpack_public_path__ + "static/sabine-92ae13b258927b19afe2eb7745de953a.jpeg";